import { Id, MetaObj } from "../../../models/framework/db";
import { Poll, PollComment, PollOption, PollType, UserPollLink } from "../../../models/poll";
import { UserInfo } from "../../../models/user/user-info";

export enum RequestedRecord {
    NEXT = 1,
    PREVIOUS = 2,
}

export interface BasePollGetReq {
    lastPollId?: string;
}

export interface UserPollGetReq extends BasePollGetReq {}

export interface FeedPollGetReq extends BasePollGetReq {
    requestedRecordType: RequestedRecord;
    requestedPollId?: string;
    categoryIds?: Array<string>;
    pollListType?: Array<PollType>;
    sessionCount?: number;
}

export interface CreatorInfo extends Pick<Id<UserInfo>, "id" | "name" | "image"> {
    isFollowing?: boolean;
}

export interface PollCard extends Poll, MetaObj {
    totalVote: number;
    totalComment: number;
    creator?: CreatorInfo;
    myVote?: Id<UserPollLink>;
    track?: boolean;
    pollSeenTime?: Date;
    isSponsored?: boolean;
}

export interface SpecialOption {
    type?: "group" | "inviteAndFollow";
    followerCount?: number;
}

export interface OptionType {
    options: Array<SpecialOption>;
}

export interface PollGetRes {
    pollList: Array<Id<PollCard>>;
}

export interface PollCart extends Poll {
    commentCount: number;
    voteCount: number;
}

export type PollVoteResponse = {
    status: boolean;
    message: string;
    pollVoteId: string;
};

export type AddCommentResponse = { status: boolean; comment: Id<PollComment> };

export interface PollTrackRequest {
    pollId: string;
    status: boolean;
}

export interface StatusResponse {
    status: boolean;
}

export interface PollBotVoteReq {
    pollId: string;
    options: Array<PollOption>;
}

export interface PollIdReq {
    pollId: string;
}
